namespace $ {
	export class $hyoo_meta_person extends $hyoo_meta_model {
		
	}
}
